import React from 'react';
import styled from 'styled-components';
import {
  Input,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Button,
  Divider,
} from '@chakra-ui/react';

import { validateIsEmail } from '../utils';

export interface StepStartProps {
  start: () => Promise<void>;
  setEmail: (email: string) => void;
  setError: (error: string | null) => void;
  email: string;
  isLoading: boolean;
  error: string | null;
  t: any;
}

export const StepStart: React.FC<StepStartProps> = ({
  isLoading,
  error,
  email,
  setEmail,
  setError,
  start,
  t,
}) => {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (!validateIsEmail(email)) {
      setError('login.invalid_email');
      return;
    }

    return await start();
  };

  const handleEmailChange = ({ target }) => {
    setEmail(target.value);
    setError(null);
  };

  return (
    <>
      <Title>{t('login.welcome')}</Title>

      <Paragraph>{t('login.start_intro')}</Paragraph>

      <Divider
        width="24px"
        margin="0 auto 40px"
        borderBottomWidth={2}
        opacity={1}
      />

      <form onSubmit={handleSubmit}>
        <FormControl isInvalid={!!error} maxWidth="280px" margin="0 auto">
          <Input
            id="email"
            type="email"
            placeholder={t('login.email')}
            value={email}
            onChange={handleEmailChange}
            isRequired
            variant="filled"
            height="44px"
            maxWidth="280px"
          />
          <FormLabel htmlFor="email">{t('login.email')}</FormLabel>
          {error && <FormErrorMessage>{t(error)}</FormErrorMessage>}
        </FormControl>

        <Button
          w="100%"
          isDisabled={isLoading || !!error}
          isLoading={isLoading}
          type="submit"
          marginTop="20px"
          height="44px"
          maxWidth="280px"
          className="bundle-button button--primary"
        >
          {t('login.continue')}
        </Button>
      </form>
    </>
  );
};

const Title = styled.h2`
  margin: 24px auto;
  font-size: 32px;
  font-weight: 600;
`;

const Paragraph = styled.h3`
  margin: 0 auto 40px;
`;
